// extracted by mini-css-extract-plugin
module.exports = {"btn":"ButtonClose_btn__2Qfg6","icon":"ButtonClose_icon__1IPMS"};